<template>
    <sa-page-layout :btnConfigurazioniVisible="true" :linkConfigurazioni="linkConfigurazioni" :btnRefreshVisible="true" :showModalLoading="showModalLoading" :pathResource="pathResource" @refresh="onRefresh" :btnNewVisible="true" :linkedit="linkedit">
        <!--     <template slot="toolbar">
            <b-button class="float-sm-right" variant="success btn-toolbar sa-margin-right" size="sm" @click="onClickNuovaIva">
                <b-icon icon="plus"></b-icon>
                Nuovo
            </b-button>
        </template> -->
        <template slot="table-filter">
            <b-form @submit.prevent="onSubmit">
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Tipologia</label>
                        <b-form-select id="inline-form-custom-select-pref" v-model="filtroConfigurazioneContabilitaSoggetti.tipologia" class="mb-2 mr-sm-2 mb-sm-0" :value="null" value-field="value" text-field="text" :options="tipologiaOptions"></b-form-select>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Ragione Sociale</label>
                        <b-form-input v-model="filtroConfigurazioneContabilitaSoggetti.ragioneSociale" type="search" id="codice"></b-form-input>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="sa-padding-right pt-3 pb-3 text-right">
                        <b-button type="submit" variant="info"> {{ this.$i18n.t("patients.lblFind") }}</b-button>
                        <b-button type="reset" v-on:click="onReset" variant="danger">{{ this.$i18n.t("patients.lblResetFilter") }}</b-button>
                    </b-col>
                </b-row>
            </b-form>
        </template>
        <template slot="table-body">
            <configurazione-contabilita-soggetti-list-component ref="cmpConfigurazioneContabilitaSoggettiList"></configurazione-contabilita-soggetti-list-component>
        </template>
    </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import ConfigurazioneContabilitaSoggettiListComponent from "../components/ConfigurazioneContabilitaSoggettiListComponent.vue";
import UtilityMixin from "../../utility/UtilityMixin";

export default {
    mixins: [UtilityMixin],
    components: { SaPageLayout, ConfigurazioneContabilitaSoggettiListComponent },
    data() {
        return {
            showModalLoading: false,
            tipologiaOptions: [],
            linkConfigurazioni: "/configurazionecontabilita",
            filtroConfigurazioneContabilitaSoggetti: { tipologia: null, ragioneSociale: null },
            linkedit: "/configurazionecontabilita/soggetti",
            pathResource: "/flussidatifatturazione",
            //   filtro: { codiceStruttura: null, idTipoDocumento: null },
        };
    },
    mounted() {
        let me = this;
        let sessionStorage = window.sessionStorage;
        me.linkedit = "/configurazionecontabilita/soggetti";
        if (sessionStorage["filtroConfigurazioneContabilitaSoggetti"]) {
            me.filtroConfigurazioneContabilitaSoggetti = JSON.parse(sessionStorage["filtroConfigurazioneContabilitaSoggetti"]);
        }
        me.loadData();
        me.loadDataFlussiFatturazioneTipologie();
    },
    methods: {
        loadData() {
            let me = this;
            me.$refs.cmpConfigurazioneContabilitaSoggettiList.loadData();
        },
        onRefresh() {
            let me = this;
            me.loadData();
        },
        loadDataFlussiFatturazioneTipologie() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResource + "/tipologie", {}, me.loadDataFlussiFatturazioneTipologieSuccess, me.loadDataFlussiFatturazioneTipologieError);
        },
        loadDataFlussiFatturazioneTipologieSuccess(response) {
            let me = this;
            me.tipologiaOptions = [];
            response.data.data.list.forEach((element) => {
                me.tipologiaOptions.push({ text: element.tipologia, value: element.tipologia });
            });
            me.tipologiaOptions.unshift({ text: "- Seleziona Tipologia -", value: null });
        },
        loadDataFlussiFatturazioneTipologieError(error) {
            let me = this;
            let messaggio = error.response.data.messaggio ? error.response.data.messaggio : "Errore nel caricamento Dati Flussi";
            me.$bvToast.toast(messaggio, {
                title: "Attenzione",
                variant: "danger",
                solid: true,
            });
        },
        onSubmit() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtroConfigurazioneContabilitaSoggetti"] = JSON.stringify(me.filtroConfigurazioneContabilitaSoggetti);

            me.loadData();
        },
        onReset() {
            let me = this;
            me.filtroConfigurazioneContabilitaSoggetti = { ragioneSociale: null, tipologia: null };
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtroConfigurazioneContabilitaSoggetti"] = JSON.stringify(me.filtroConfigurazioneContabilitaSoggetti);
            me.loadData();
        },
    },
};
</script>

<style></style>
